export const LANGUAGE = "LANGUAGE"
